import React from "react";
import styled from "styled-components";


const QuestionNumber = styled.div`
    border: 1px solid #4d71e5;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #4D71E5;
    color: white;
    text-align: center;
    margin-right: 20px;
`

const QuestionNumberP = styled.p`
    width: 18px;
    height: 18px;
    margin: 0;
    font-size: 13px;
    line-height: 19px;
`

const FlexBox = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: start;
    margin-bottom: 0;
    margin-left: -40px;
    width: ${props => props.width};

    @media (max-width: 768px) {
        margin-left: -25px;
        
        width: auto;
    }
    @media (max-width: 576px) {
        margin-left: ${props => props.marginLeft ? props.marginLeft : '-25px'};
        margin-bottom: 20px;
        width: auto;
    }
`;

const QuestionH3 = styled.h3`

    font-size: 18px;
    @media (max-width: 768px) {
        font-size: 16px;
    }
    @media (max-width: 576px) {
        font-size: 14px;
    }


`

const QuestionBox = (props) => {
    // console.log(props)
  return (
    <FlexBox marginLeft={props.marginLeft} width={props.width ? props.width : 'auto'} style={{ alignItems: 'center'}}>
        <QuestionNumber >
            <QuestionNumberP>{props.index}</QuestionNumberP>
        </QuestionNumber>
        <div style={{color: props.color}}>

            {props.view == 2 ? 
            <>
                <QuestionH3 style={{fontWeight: 'normal', marginBottom: '8px', marginRight: '10px'}}>{props.question.split('?')[0]+"?"}</QuestionH3>
                <p style={{margin: '0'}}>{props.question.split('?')[1]}</p>
            </>
            
            
            : <QuestionH3 style={{fontWeight: 'normal', marginRight: '10px'}}>
                {props.question}
            </QuestionH3>
            }
        </div>
    </FlexBox>
  );
};

export default QuestionBox;